import { Pipe, PipeTransform } from '@angular/core';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
import { AppSettings } from '../app.settings';
@Pipe({
  name: 'datetimeformat'
})
export class DateTimeFormatPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    return moment(value).format(AppSettings.DATE_TIME_FORMAT_MOMENT);
    // return moment(value).format('hh:mm a');
  }

}
